// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__tableHeader--sxSvB {
  display: flex;
  flex-direction: row;
  position: sticky;
  top: 0;
  background-color: #fafafa;
  z-index: 3;
  width: 100%;
  min-width: fit-content;
  border-bottom: 1px solid #e2e2e2;
}
.src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__headerItem--pN93z {
  position: relative;
  flex: 1;
  padding: 16px 24px;
  text-align: left;
  overflow: hidden;
  font-size: 12px;
  font-weight: 400;
  color: #767c84;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  min-width: 150px;
  border-left: 1px solid #e2e2e2;
  height: 100%;
}
.src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__headerItem--pN93z:first-child {
  border-left: none;
}
.src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__headerItem--pN93z:last-child {
  border-right: 1px solid #e2e2e2;
}
.src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__headerItemSorted--Z6F5U {
  background: #f5f5f5;
}
.src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__headerItemSelection--I31U7 {
  flex: none;
  min-width: unset;
  width: 75px;
  display: flex;
  justify-content: center;
}
.src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__headerItemSelection--I31U7 > * {
  width: 16px;
  height: 16px;
}
.src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__columnHeaderContent--O3NCB {
  flex-grow: 1;
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EntityFiltersPage/AsyncTableView/templates/ATVHeaderStd/ATVHeaderStd.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,gCAAA;AACF;AAEA;EACE,kBAAA;EACA,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,YAAA;AAAF;AACE;EACE,iBAAA;AACJ;AACE;EACE,+BAAA;AACJ;AAGA;EACE,mBAAA;AADF;AAIA;EACE,UAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAFF;AAGE;EACE,WAAA;EACA,YAAA;AADJ;AAKA;EACE,YAAA;EACA,iBAAA;AAHF","sourcesContent":[".tableHeader {\n  display: flex;\n  flex-direction: row;\n  position: sticky;\n  top: 0;\n  background-color: #fafafa;\n  z-index: 3;\n  width: 100%;\n  min-width: fit-content;\n  border-bottom: 1px solid #e2e2e2;\n}\n\n.headerItem {\n  position: relative;\n  flex: 1;\n  padding: 16px 24px;\n  text-align: left;\n  overflow: hidden;\n  font-size: 12px;\n  font-weight: 400;\n  color: #767c84;\n  background-color: #fafafa;\n  display: flex;\n  align-items: center;\n  min-width: 150px;\n  border-left: 1px solid #e2e2e2;\n  height: 100%;\n  &:first-child {\n    border-left: none;\n  }\n  &:last-child {\n    border-right: 1px solid #e2e2e2;\n  }\n}\n\n.headerItemSorted {\n  background: #f5f5f5;\n}\n\n.headerItemSelection {\n  flex: none;\n  min-width: unset;\n  width: 75px;\n  display: flex;\n  justify-content: center;\n  & > * {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.columnHeaderContent {\n  flex-grow: 1;\n  user-select: none; // Предотвращает выделение текста при перетаскивании\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableHeader": `src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__tableHeader--sxSvB`,
	"headerItem": `src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__headerItem--pN93z`,
	"headerItemSorted": `src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__headerItemSorted--Z6F5U`,
	"headerItemSelection": `src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__headerItemSelection--I31U7`,
	"columnHeaderContent": `src-pages-EntityFiltersPage-AsyncTableView-templates-ATVHeaderStd-ATVHeaderStd-module__columnHeaderContent--O3NCB`
};
export default ___CSS_LOADER_EXPORT___;
